import React from "react";
import { ReactComponent as ExcelIcon } from "../assets/excel.svg";
import "../main.css";
import { PrimaryCTALink } from "../../components/PrimaryCTA";
import axios from "axios";
import { Card, Grid } from "semantic-ui-react";
import { resourceUrls } from "../../config";
import Lottie from "react-lottie-player";
import Spinner from "../assets/spinner.json";

export default class UploadSheet extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    state = {
        uploadErrorText: "",
        error: "",
        spinnerActive: false,
    };

    handleSubmit() {
        if (!this.props.selectedFile) {
            this.setState({ uploadErrorText: "PLEASE ADD A SHEET" });
            return;
        }

        if (!this.props.selectedFile.name.endsWith(".xlsx")) {
            this.setState({
                uploadErrorText:
                    "Sorry, we can't process this spreadsheet. Check that it's a MyTutor spreadsheet, and that it's a recent copy",
            });
            return;
        }

        const formData = new FormData();

        formData.append(
            "file",
            this.props.selectedFile,
            this.props.selectedFile.name
        );

        this.setState({ spinnerActive: true });

        axios
            .post(resourceUrls.schools.formValidatorSummary, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(response => {
                if (response.data.fields.length === 0) {
                    this.setState({
                        error:
                            "It seems like you've uploaded a blank sheet! Please check your Excel Form has your student's details!",
                    });
                    this.setState({ spinnerActive: false });
                    return;
                }
                this.props.setGroupedResponse(response.data);
                this.props.setFileUploaded(true);
            })
            .catch(error => {
                if (error.response) {
                    this.setState({ error: error.response.data.message });
                } else if (error.message !== "") {
                    this.setState({ error: error.message });
                } else if (error.response.error !== "") {
                    this.setState({ error: error.response.error });
                }

                this.setState({ spinnerActive: false });
            });

        axios
            .post(resourceUrls.schools.formValidator, formData)
            .then(response => {
                if (response.data.sheets.length === 0) {
                    this.setState({
                        error:
                            "It seems like you've uploaded a blank sheet! Please check your Excel Form has your student's details!",
                    });
                    this.setState({ spinnerActive: false });
                    return;
                }
                this.props.setSingleResponse(response.data);
            })
            .catch(error => {
                if (error.response) {
                    this.setState({ error: error.response.data.message });
                } else if (error.message !== "") {
                    this.setState({ error: error.message });
                } else if (error.response.error !== "") {
                    this.setState({ error: error.response.error });
                }

                this.setState({ spinnerActive: false });
            });
    }

    onFileChange = event => {
        this.props.setSelectedFile(event.target.files[0]);
        this.setState({ uploadErrorText: "" });
    };

    fileData = () => {
        if (this.props.selectedFile) {
            return (
                <>
                    <p>{this.props.selectedFile.name}</p>
                    <p style={{ color: "#542eff" }}>CHOOSE ANOTHER SHEET</p>
                </>
            );
        } else {
            return (
                <p
                    style={{
                        color: "#542eff",
                        fontFamily: "Modelica",
                    }}
                >
                    CHOOSE A SHEET TO UPLOAD
                </p>
            );
        }
    };

    render() {
        return (
            <>
                <Card className="border-top-purple p-4 w-100" centered>
                    <Card.Header>
                        <h3
                            style={{
                                fontSize: "27px",
                                fontFamily: "Modelica",
                                fontWeight: 800,
                            }}
                        >
                            Upload your sheet
                        </h3>
                    </Card.Header>
                    <Card.Content className="border-top-none">
                        <Card.Description>
                            <p>
                                Upload your completed excel spreadsheet below.
                                Once uploaded, we'll run some quick checks to
                                make sure the data is complete and formatted
                                correctly.
                            </p>
                        </Card.Description>
                    </Card.Content>
                    <Card.Content className="border-top-none pb-3">
                        <Grid
                            stretched
                            verticalAlign="middle"
                            textAlign="center"
                        >
                            <ExcelIcon className="p-0" />
                            <label
                                htmlFor="file-upload"
                                className="custom-file-upload"
                            >
                                <i className="fa fa-cloud-upload"></i>{" "}
                                {this.fileData()}
                            </label>
                            <input
                                id="file-upload"
                                type="file"
                                onChange={this.onFileChange}
                            />
                        </Grid>
                    </Card.Content>
                    <Card.Content className="border-top-none pt-3">
                        <Card.Description>
                            {this.state.spinnerActive ? (
                                <Lottie
                                    play
                                    loop
                                    animationData={Spinner}
                                    style={{
                                        height: "150px",
                                        width: "150px",
                                        margin: "auto",
                                    }}
                                />
                            ) : (
                                <PrimaryCTALink
                                    type="button"
                                    disabled={this.props.selectedFile == null}
                                    onClick={this.handleSubmit}
                                    style={{
                                        fontFamily: "Modelica",
                                        fontWeight: 800,
                                    }}
                                >
                                    UPLOAD SHEET
                                </PrimaryCTALink>
                            )}
                        </Card.Description>
                    </Card.Content>
                    <p className="color-error">{this.state.uploadErrorText}</p>
                    <p className="color-error">{this.state.error}</p>
                </Card>
            </>
        );
    }
}
